/* Theme custom file */
class OperationCountdown extends HTMLElement {
  connectedCallback() {
    this.targetTimestamp = parseInt(this.dataset.target, 10) * 1000;
    if (!this.targetTimestamp) return;

    this.daysEl = this.querySelector('[data-countdown-days]');
    this.hoursEl = this.querySelector('[data-countdown-hours]');
    this.minutesEl = this.querySelector('[data-countdown-minutes]');
    this.daysFrame = this.querySelector('[data-unit="days"]');
    this.daysSep = this.querySelector('[data-countdown-days-sep]');

    this.update();
    this.interval = setInterval(() => this.update(), 60000);
  }

  disconnectedCallback() {
    if (this.interval) clearInterval(this.interval);
  }

  update() {
    const remaining = this.targetTimestamp - Date.now();
    const totalSeconds = Math.max(0, Math.floor(remaining / 1000));
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);

    if (this.daysEl) this.daysEl.textContent = String(days).padStart(2, '0');
    if (this.hoursEl) this.hoursEl.textContent = String(hours).padStart(2, '0');
    if (this.minutesEl) this.minutesEl.textContent = String(minutes).padStart(2, '0');

    if (this.daysFrame && this.daysSep) {
      const hide = days === 0;
      this.daysFrame.hidden = hide;
      this.daysSep.hidden = hide;
    }
  }
}

if (!customElements.get('operation-countdown')) {
  customElements.define('operation-countdown', OperationCountdown);
}
